import * as actionTypes from './actiontypes';
import { PAGE_LOADING, PAGE_LOADED } from '../page_details/actiontypes';
import * as API from './api';
import { log, showMessage } from '../../config/utils';

export function updateEntityState(payload, path) {
    return function (dispatch) {
        dispatch({
            type: actionTypes.UPDATE_ENTITY_STATE,
            payload,
            path
        });
    };
}

export function deleteEntityState(path) {
    return function (dispatch) {
        dispatch({
            type: actionTypes.DELETE_ENTITY_STATE,
            path
        });
    };
}

export function fetchAllEntities() {
    return function (dispatch) {
        dispatch({
            type: actionTypes.ALL_ENTITIES_LOADING,
        });
        API.fetchAllEntities({}, (error, response) => {
            log('all entities response:', response);
            if (!error) {
                dispatch({
                    type: actionTypes.ALL_ENTITIES_LOADED,
                    payload: response,
                });
            } else {
                dispatch({
                    type: actionTypes.ALL_ENTITIES_LOAD_ERROR,
                });
            }
        });
    };
}

export function deleteEntity(data) {
    return function (dispatch) {
        dispatch({
            type: PAGE_LOADING,
            payload: "Deleting Entity"
        });
        API.deleteEntity(data, (error, response) => {
            log('delete entity response:', response);
            dispatch({
                type: PAGE_LOADED,
            });
            if (!error && response) {
                dispatch({
                    type: actionTypes.ENTITY_DELETED,
                    payload: response
                });
                showMessage('success', response.message ? response.message : 'entity successfully deleted.');
            }
        });
    };
}

export function createEntity(data, closeModal) {
    return function (dispatch) {
        dispatch({
            type: actionTypes.ENTITY_CREATING,
        });
        API.createEntity(data, (error, response) => {
            log('create entity response:', response);
            if (!error && response) {
                dispatch({
                    type: actionTypes.ENTITY_CREATED,
                    payload: response
                });
                showMessage('success', response.message ? response.message : 'entity successfully created.');
                if (closeModal) closeModal();
            } else {
                dispatch({
                    type: actionTypes.ENTITY_CREATION_FAILED,
                    payload: response
                });
            }
        });
    };
}

export function getEntityData(data) {
    return function (dispatch) {
        dispatch({
            type: actionTypes.ENTITY_DATA_LOADING,
        });
        API.getEntityData(data, (error, response) => {
            log('get entity data response:', response);
            if (!error && response && response.data) {
                dispatch({
                    type: actionTypes.ENTITY_DATA_LOADED,
                    payload: response,
                });
            } else {
                dispatch({
                    type: actionTypes.ENTITY_DATA_LOAD_ERROR,
                });
            }
        });
    };
}

export function updateEntity(payload, callback) {
    return function (dispatch) {
        dispatch({
            type: actionTypes.ENTITY_UPDATING,
        });
        API.updateEntity(payload, (error, response) => {
            log('update entity response:', response);
            if (!error && response) {
                dispatch({
                    type: actionTypes.ENTITY_UPDATED,
                    payload: response
                });
                showMessage('success', response.message ? response.message : 'entity successfully created.');
                if (callback) callback();
            } else {
                dispatch({
                    type: actionTypes.ENTITY_UPDATION_ERROR,
                });
            }
        });
    };
}



// WEBPACK FOOTER //
// ./src/data/redux/entity_details/actions.js